/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmConversationsList } from "../../funcs/llmConversationsList.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ConversationsListRequest$inboundSchema,
};

export const tool$llmConversationsList: ToolDefinition<typeof args> = {
  name: "llm-conversations-list",
  description: `List conversations

List all conversations for the authenticated user with pagination support.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmConversationsList(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
